import type { WidgetPreviewConfig } from './types';
import { WidgetAvatar } from './widget-avatar';
import { MessageTailIcon } from './widget-icons';
import styles from './widget-preview.module.scss';

export const TypingIndicator = ({ config }: { config: WidgetPreviewConfig }) => (
  <div
    className={`${styles.messageRow} ${styles.typingRow}`}
    role="status"
    aria-label={config.demo.assistantTypingAriaLabel}
  >
    <span className={styles.avatarSlot}>
      <WidgetAvatar appearance={config.appearance} size={32} className={styles.avatar} />
    </span>
    <span
      className={`${styles.messageBubble} ${styles.assistantBubble}`}
      style={{ borderRadius: config.messages.borderRadius }}
    >
      {config.messages.tailEnabled && (
        <span className={`${styles.messageTail} ${styles.assistantMessageTail}`}>
          <MessageTailIcon />
        </span>
      )}
      <span className={styles.typingDots}>
        <span />
        <span />
        <span />
      </span>
    </span>
  </div>
);
